const CreateStripePaymentIntentForMyCurrentClientContractorsResultType =
  Object.freeze({
    SUCCESS: 1,
    CLIENT_HAS_NO_UNPAID_CONTRACTOR: 2,
    CLIENT_HAS_PROCESSING_OR_SUCCEED_PAYMENT_INTENT: 3,
  });

export default CreateStripePaymentIntentForMyCurrentClientContractorsResultType;
